<template>
  <div class="layout-inner career_prospects">

    <navbar></navbar>

    <div class="layout-container">
      <div class="layout-content" style="position: relative;">

        <template v-if="isLoading">
          <div class="w-100 h-100 d-flex justify-content-center align-items-center">
            <spinner size="large"></spinner>
          </div>
        </template>

        <template v-else>

          <template v-if="programGuide && programGuide.title">
            <program-guide-title :program-guide="programGuide"></program-guide-title>
          </template>

          <div class="row list_view" v-if="showAlumniData">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
              <div class="row pg_sec" style="padding-bottom: 0px;">
                <div class="col-12">
                  <div class="row result_row" v-if="spotlightAlumni">
                    <div class="col-4 thumbnail_container">
                      <div class="thumbnail_container_inner">
                        <img class="thumb_img"
                          v-if="spotlightAlumni.thumbnailURI"
                          :src="spotlightAlumni.thumbnailURI"
                          tabindex="0"
                          onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
                        <div v-else class="default_thumb">
                          <span class="ic ic-degreeProgram"></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-8 entity_details">
                      <div class="row entity_title mb-1" style="margin-right: 0px;">
                        <div class="col-12 title_txt ace_sec_txt" :aria-label="spotlightAlumni.title" style="padding-left: 0px; padding-right: 0px;">{{spotlightAlumni.title}}{{getClassOf(spotlightAlumni)}}</div>
                      </div>
                      <div class="row">
                        <div class="col-12 description ace_sec_txt" id="biography" v-if="spotlightAlumni.biography" style="padding-left: 0px; padding-right: 0px;">
                           <span class="desc_txt" v-html="spotlightAlumni.biography"></span>
                        </div>
                        <div class="col-12 no_description empty_pattern ace_sec_txt" v-else>
                          Biography not added
                        </div>
                        <template v-if="spotlightAlumni.biography && spotlightAlumni.biography.length > 100">
                          <div class="program_desc col-12">
                            <b-link v-b-modal="'progDesc_' + spotlightAlumni.uuid" style="color: #0645AD; float: right; text-align: right; padding-top: 8px;">more</b-link>

                            <b-modal :id="'progDesc_' + spotlightAlumni.uuid" :title="spotlightAlumni.title" hide-footer>
                              <div v-if="spotlightAlumni.biography" v-html="spotlightAlumni.biography"></div>
                            </b-modal>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <template v-if="showCareerEmoloyerJob">
                    <div class="row alumni_data_section">
                      <div class="col-12">

                        <div class="row">
                          <div class="col-12 hd">
                            <h2 class="hd_txt">Alumni Data</h2>
                            <span class="hd_bdr"></span>
                          </div>
                        </div>

                        <div class="row content_sec jobs_outlook national_data">
                          <div class="card col-12 alumni_data_card" v-if="alumniData && alumniData.topCareerTitle">
                            <div class="row card-body">
                              <template>
                                <div class="col-6 crd_data" :aria-label="'Most Popular Alumni Career ' + alumniData.topCareerTitle">
                                  <div class="row">
                                    <template v-if="alumniData.topCareerThumbnail">
                                      <div class="col-12 text-center" style="top: -5px;">
                                        <div v-if="alumniData.topCareerThumbnail">
                                          <img v-bind:src="alumniData.topCareerThumbnail" style="height: 50px; width: 50px;">
                                        </div>
                                      </div>
                                    </template>
                                    <div class="col-12 text-center">
                                      <h6 style="color: #6eacc8;"><strong>{{alumniData.topCareerTitle}}</strong></h6>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6 crd_title">
                                  <div class="title_txt">
                                    <div class="txt_1">Most Popular Alumni Career</div>
                                 </div>
                                </div>
                              </template>
                            </div>
                          </div>

                          <div class="card col-12 alumni_data_card" v-if="alumniData && alumniData.topCompanyTitle">
                            <div class="row card-body">
                              <template>
                                <div class="col-6 crd_data" :aria-label="'Company with most alumni ' + alumniData.topCompanyTitle">
                                  <div class="row">
                                    <div class="col-12 alumni_company">
                                      {{alumniData.topCompanyTitle}}
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6 crd_title">
                                  <div class="title_txt">
                                    <div class="txt_1">Company with most alumni</div>
                                 </div>
                                </div>
                              </template>
                            </div>
                          </div>

                          <div class="card col-12 alumni_data_card" v-if="alumniData && alumniData.totalHireLastYearHire" >
                            <div class="row card-body">
                              <template>
                                <div class="col-6 crd_data" :aria-label="'Number of hires last year ' + alumniData.totalHireLastYearHire">
                                  <div class="row">
                                    <div class="col-12 hirings_count">
                                      <span>{{alumniData.totalHireLastYearHire}}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-6 crd_title">
                                  <div class="title_txt">
                                    <div class="txt_1">Number of hires last year</div>
                                 </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 lnk_container">
                            <a href="javascript:void(0);" @click="navigateToSpotlightAlumni">Learn about alumni companies and careers</a>
                          </div>
                        </div>

                      </div>
                    </div> <!-- .alumni_data_section -->
                  </template>
                </div>
              </div>
            </div>
          </div>


          <template v-if="isEMSIFeatureEnabled">

            <div class="sub_hd_bar">
              <div class="sub_hd_ic">
                <span @click="isStateCityFilterClicked = true" class="filter">
                  <span class="ic ic-filter "></span>
                  <template v-if="!isStateCityFilterClicked">
                    <span class="count" v-if="selectedState || selectedMetroArea">
                      <span>1</span>
                    </span>
                  </template>
                </span>
              </div>
              <div class="filter_sub_hd_txt">
                <template v-if="!isStateCityFilterClicked && (selectedState || selectedMetroArea)">
                  <div v-if="selectedState">
                    <span>{{selectedState.label}}</span>
                  </div>
                  <div v-if="selectedMetroArea">
                    <span>{{selectedMetroArea.label}}</span>
                  </div>
                </template>
                <template v-else>
                  <span>US Data</span>
                </template>
              </div>
            </div>

          </template>

          <div class="container-fluid flex-grow-1 pg_content_container" style="padding-top: 0px;">

              <div v-if="isStateCityFilterClicked" class="filter_selection_flds_container">

                <div class="filter_fld_head">
                  <div class="hd_txt">Filter by State or City</div>
                </div>

                <div>
                  <div class="filter_city_state">
                    <b-input-group class="row">
                      <div class="w-100">
                        <div>
                          <label for="state">Select State</label>
                          <v-select class="select-field" :disabled="disableSelectState" v-model='selectedState'
                            :options='formattedGeoIdMap.stateGeoIds' placeholder="Select or Search for a State" :class="!selectedState ? 'no_value_selected' : ''" :style="{'background-color': (!disableSelectState) ? '#f8eac9' : ''}"></v-select>
                          <span class="fld_info">
                            <span v-if="disableSelectState">To select state clear the city selection first</span>
                          </span>
                        </div>
                        <div class="mt-2 text-center">
                          <label><strong>OR</strong></label>
                        </div>
                        <div style="margin-top: -15px">
                          <label for="city">Select City</label>
                          <v-select class="select-field" :disabled="disableSelectMetroArea" v-model='selectedMetroArea'
                            :options='formattedGeoIdMap.msaGeoIds' placeholder="Select or Search for a City" :class="!selectedMetroArea ? 'no_value_selected' : ''" :style="{'background-color': (!disableSelectMetroArea) ? '#ffebed' : ''}"></v-select>
                          <span class="fld_info">
                            <span v-if="disableSelectMetroArea">To select city clear the state selection first</span>
                          </span>
                        </div>
                      </div>
                    </b-input-group>
                  </div>
                  <!--
                  <div class="ml-4" style="position: fixed; bottom: 160px;">
                    <template v-if="selectedState || selectedMetroArea">
                      <div v-if="selectedState">
                        <span>{{selectedState.label}}</span>
                      </div>
                      <div v-if="selectedMetroArea">
                        <span>{{selectedMetroArea.label}}</span>
                      </div>
                    </template>
                    <template v-else>
                      <span>US Data</span>
                    </template>
                  </div>
                  -->
                  <div class="btn_container">
                    <b-btn @click="careerSearchClicked">ok</b-btn>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="isEMSIFeatureEnabled" class="row">

                    <b-tabs v-model="tabIndex">
                      <b-tab no-body title="Jobs" :title-link-class="linkClass(0)" title-item-class="text-center">
                        <div class="row jobs_sec">

                          <div class="col-sm-3 col-xl-3 hd" style="margin-top: 20px;">
                            <h2>Job Posting Overview</h2>
                            <span class="hd_bdr"></span>
                          </div>

                          <div class="col-sm-3 col-xl-3" v-if="formattedCareer && formattedCareer.aggregatedMedianHourlyEarning">
                            <div class="card sec_bx">
                              <div class="card-body">
                                <div class="row sec_row income_sec">

                                  <div class="col-3 ic_container">
                                    <span class="ic ic9-salary"></span>
                                  </div>
                                  <div class="col-6 val">
                                    $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                                  </div>
                                  <div class="col-3 label">
                                    Median Income
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-sm-3 col-xl-3" v-if="formattedCareer && formattedCareer.aggregatedGrowthPercentage && !selectedMetroArea">
                            <div class="card sec_bx">
                              <div class="card-body">
                                <div class="row sec_row growth">

                                  <div class="col-4 gph_chart">
                                    <div class="row lg_row">
                                      <div class="col-6 lg">
                                        <span class="lg_txt">0%</span>
                                      </div>
                                      <div class="col-6 lg">
                                        <span class="lg_txt">15%</span>
                                      </div>
                                    </div>
                                    <div class="row gauge_sec">
                                      <div class="col-12">
                                        <doughnut-chart :chart-data="growthPieData(formattedCareer.aggregatedGrowthPercentage)" id="bgt-gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('bgt-gauge', formattedCareer.aggregatedGrowthPercentage)"></doughnut-chart>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-5 val">
                                    {{formattedCareer.aggregatedGrowthPercentage}} %
                                  </div>
                                  <div class="col-3 label">
                                    Estimated Job Growth 2020-2030
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-sm-3 col-xl-3" v-if="formattedCareer && formattedCareer.aggregatedLastYearJob">
                            <div class="card sec_bx">
                              <div class="card-body">
                                <div class="row sec_row">

                                  <div class="col-3 ic_container">
                                    <span class="ic ic9-job2"></span>
                                  </div>
                                  <div class="col-6 val">
                                    <span v-html="addCommaInNumber(formattedCareer.aggregatedLastYearJob)"></span>
                                  </div>
                                  <div class="col-3 label">
                                    <div>
                                      Job Postings 2020 - 2030
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>


                          <div class="col-sm-3 col-xl-3 mt-3 mb-3 career_chart_container">
                            <div class="row">
                              <div class="col-12 hd">
                                <div class="hd_txt">
                                  <h2>Top Careers</h2>
                                  <span class="hd_bdr"></span>
                                </div>
                                <div class="ace_sec_hd lnk_sec">
                                  <template v-if="showEducationLevelEnabled">
                                    <template v-if="showAllOccupations">
                                      [<b-link @click="toggleShowOccupations()">Show Careers At Your Program Level</b-link>]
                                    </template>
                                    <template v-if="!showAllOccupations">
                                      [<b-link @click="toggleShowOccupations()">Show All Careers</b-link>]
                                    </template>
                                  </template>
                                </div>
                              </div>
                            </div>

                            <!-- custom career chart -->
                            <div class="row pg_sec">

                              <div class="col-12 ace_sec" aria-label="Careers Chart">

                                <div class="col-1 tags_legend">
                                  <div class="btn tags_legend_icon" id="popoverTarget2_eduLevelTags">
                                    <div class="ic_info">i</div>
                                  </div>
                                  <b-popover ref="educationLevelTagsLagends" target="popoverTarget2_eduLevelTags" triggers="click" placement="bottom" class="chart_tooltip_popover" container="eduLevelTagsLagends">
                                    <div class="tooltip_row tag_edu_level">
                                      <div class="popup_hd row">
                                        <div class="hd_txt col-11">
                                          Legend
                                        </div>
                                        <div class="btn_container col-1">
                                          <button class="btn_close" aria-label="close" @click="closeEducationLevelTagsLegendsPopup">
                                            <span class="ic-close"></span>
                                          </button>
                                        </div>
                                      </div>

                                      <div class="edu_tag_row">
                                        <div class="edu_level edu_H">H</div>
                                        <div class="tag_detail">
                                          High School or Vocational Training
                                        </div>
                                      </div>
                                      <div class="edu_tag_row">
                                        <div class="edu_level edu_C">C</div>
                                        <div class="tag_detail">
                                          Post Secondary Diploma or Certificate
                                        </div>
                                      </div>
                                      <div class="edu_tag_row">
                                        <div class="edu_level edu_A">A</div>
                                        <div class="tag_detail">
                                          Associate's Degree
                                        </div>
                                      </div>
                                      <div class="edu_tag_row">
                                        <div class="edu_level edu_B">B</div>
                                        <div class="tag_detail">
                                          Bachelor's Degree
                                        </div>
                                      </div>
                                      <div class="edu_tag_row">
                                        <div class="edu_level edu_M">M</div>
                                        <div class="tag_detail">
                                          Master's Degree
                                        </div>
                                      </div>
                                      <div class="edu_tag_row">
                                        <div class="edu_level edu_D">D</div>
                                        <div class="tag_detail">
                                          Doctorate's Degree
                                        </div>
                                      </div>


                                    </div>
                                  </b-popover>

                                  <div id="eduLevelTagsLagends" class="chart_tooltip_popover"></div>
                                </div>

                                <!--
                                <div class="avg_val ace_sec_txt" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                                  <span class="avg_val_txt">
                                    Median Income - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                                  </span>
                                </div>
                                -->
                                <div class="avg_val_connecter"></div>

                                <div class="bar_chart_container bar_label_inside">
                                  <template v-for="(formattedCareer, index) in targetOccupationItems">
                                    <div class="row bar_row ace_sec">
                                      <div class="col-12 accordion acrdn_top_careers">
                                        <!--
                                        <div id="careersDetailsToolTip" class="chart_tooltip_popover"></div>
                                        <b-popover :target="'popoverCareersDetails_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="careersDetailsToolTip">
                                          <div class="tooltip_row">
                                             <div class="val">{{ formattedCareer.name }}</div>
                                          </div>
                                          <div class="tooltip_row">
                                            <div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.medianHourlyEarning)"></span></div>
                                          </div>
                                        </b-popover>
                                        -->
                                        <b-card no-body class="graphs_sec">

                                          <b-card-header header-tag="header" class="row_hd" role="tab">
                                            <b-button block v-b-toggle="'acrdnTopCareer_' + index" variant="info">
                                              <span class="btn_txt" @click.stop="navigateToCareer(formattedCareer)">{{ formattedCareer.Occupation }}</span>
                                              <span class="ic ic8-circle-up"></span>
                                              <span class="ic ic8-circle-down"></span>
                                            </b-button>
                                          </b-card-header>

                                          <b-collapse :visible="index === 0" :id="'acrdnTopCareer_' + index" accordion="careers-accordion" role="tabpanel">
                                            <b-card-body class="graphs_sec_inner">

                                              <div class="bar_label"></div>

                                              <div class="card sec_bx">
                                                <div class="card-body">
                                                  <div class="row sec_row income_sec">

                                                    <div class="col-3 ic_container">
                                                      <span class="ic ic9-salary"></span>
                                                    </div>
                                                    <div class="col-6 val">
                                                      <span v-html="'$' + addCommaInNumber(formattedCareer['Median Earnings'])"></span>
                                                    </div>
                                                    <div class="col-3 label">
                                                      Median Income
                                                    </div>

                                                  </div>
                                                </div>
                                              </div>

                                              <div class="card sec_bx">
                                                <div class="card-body">
                                                  <div class="row sec_row growth">

                                                    <div class="col-4 gph_chart">
                                                      <div class="row lg_row">
                                                        <div class="col-6 lg">
                                                          <span class="lg_txt">0%</span>
                                                        </div>
                                                        <div class="col-6 lg">
                                                          <span class="lg_txt">15%</span>
                                                        </div>
                                                      </div>
                                                      <div class="row gauge_sec">
                                                        <div class="col-12">
                                                          <doughnut-chart :chart-data="growthPieData(formattedCareer['Growth (2020-2030)'])" :id="'bgt-gauge_' + index" :options="growthPieOptions" @afterComplete="callDrawNeedle('bgt-gauge_' + index, formattedCareer['Growth (2020-2030)'])"></doughnut-chart>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-5 val">
                                                      <span v-html="formattedCareer['Growth (2020-2030)'] + '%'"></span>
                                                    </div>
                                                    <div class="col-3 label">
                                                      Estimated Job Growth 2020-2030
                                                    </div>

                                                  </div>
                                                </div>
                                              </div>

                                              <div class="card sec_bx">
                                                <div class="card-body">
                                                  <div class="row sec_row">

                                                    <div class="col-3 ic_container">
                                                      <span class="ic ic9-job2"></span>
                                                    </div>
                                                    <div class="col-6 val">
                                                      <span v-html="addCommaInNumber(formattedCareer['Annual Openings'])"></span>
                                                    </div>
                                                    <div class="col-3 label">
                                                      <div>
                                                        Job Postings 2020 - 2030
                                                      </div>
                                                    </div>

                                                  </div>
                                                </div>
                                              </div>

                                              <div class="bar_container jobs">
                                                <div class="edu_label" v-if="showEducationLevelEnabled">
                                                  <template v-for="edu in formattedCareer['Education'] ">
                                                    <div class="tag ace_sec_txt" v-if="edu.score !== '0.0'">
                                                      <span class="edu_level" :class="'edu_' + edu.level.charAt(0)" :title="edu.level">
                                                        {{edu.level.charAt(0)}}
                                                      </span>
                                                      <span class="edu_score"><span v-html="formatNumericVal(edu.score)"></span>%</span>
                                                    </div>
                                                  </template>
                                                </div>
                                                <!--
                                                <div class="bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer['Median Earnings'])"></span></div>
                                                <div class="bar" v-bind:style="{width:setIncomeBarWidth(formattedCareer['Median Earnings'])}"></div>
                                                -->
                                              </div>

                                            </b-card-body>
                                          </b-collapse> <!-- collapse -->

                                        </b-card>

                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </div>

                            </div>
                            <!-- custom career chart -->

                            <!--
                            <div class="custom_dot_gph_conatiner">
                              <div class="career_chart">
                                <scatter-chart :data="incomeScatterData" :options="incomeScatterOptions" :height="50"></scatter-chart>
                              </div>
                              <div class="line"></div>
                            </div>
                            <div class="text-center">
                              Median Income - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                            </div>
                            -->

                          </div>
                        </div>
                      </b-tab>


                      <b-tab no-body title="Companies" :title-link-class="linkClass(1)" title-item-class="text-center">
                        <div class="row mt-1">
                          <template v-if="topCompaniesItems && topCompaniesItems.length > 0">
                            <div class="col-sm-12 col-xl-3 hd" style="margin-top: 20px;">
                              <h2>Top Companies by Number of Job Postings</h2>
                              <span class="hd_bdr"></span>
                            </div>
                            <div class="col-sm-12 col-xl-3 tree_map_container">
                              <div class="row time_chart_container chart_companies_posting">
                                <div class="col-12">
                                  <template v-for="(topCompaniesItems, index) in topCompaniesItems">
                                    <div class="bar_block">
                                      <div id="companiesPostingToolTip" class="chart_tooltip_popover"></div>
                                      <b-popover :target="'popoverTarget_' + index" triggers="hover" placement="top" class="tooltip_popover" container="companiesPostingToolTip">
                                        <div>
                                          <div><span v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
                                        </div>
                                        <div>
                                          <div>Postings</div>
                                          <div><span v-html="addCommaInNumber(topCompaniesItems.Total)"></span></div>
                                        </div>
                                      </b-popover>
                                      <div :id="'popoverTarget_' + index">
                                        <div class="row bar_block_inner">
                                          <div class="bar_title"><span v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
                                          <div class="bar_val_1">Postings <span v-html="addCommaInNumber(topCompaniesItems.Total)"></span></div>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </b-tab>


                      <b-tab no-body title="Skills" :title-link-class="linkClass(2)" title-item-class="text-center">
                        <template v-if="topSkillsItems && topSkillsItems.length > 0">

                          <div class="row">
                            <div class="col-sm-3 col-xl-3 hd" style="margin-top: 20px;">
                              <h2>Top In-Demand Skills within Job Postings</h2>
                              <span class="hd_bdr"></span>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12 col-xl-3 col-12 tree_map_container">
                              <div class="row time_chart_container chart_companies_posting">
                                <div class="col-12">
                                  <template v-for="(topSkillsItems, index) in topSkillsItems">
                                    <div class="bar_block">

                                      <div id="skillsToolTip" class="chart_tooltip_popover"></div>
                                      <b-popover :target="'popoverTarget2_skill_' + index" triggers="hover" placement="top" class="tooltip_popover" container="skillsToolTip">
                                        <div>
                                          <div class="label">Skill</div>
                                          <div class="val">{{topSkillsItems.Skill}}</div>
                                        </div>
                                        <div>
                                          <div class="label">Postings</div>
                                          <div><span v-html="addCommaInNumber(topSkillsItems.Postings_with_Skill)"></span></div>
                                        </div>
                                      </b-popover>

                                      <div class="bar_block_inner" :id="'popoverTarget2_skill_' + index">
                                        <div class="row">
                                          <div class="col-12 bar_title">{{ topSkillsItems.Skill }} </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-6 bar_val_1">Postings <span v-html="addCommaInNumber(topSkillsItems.Postings_with_Skill)"></span></div>
                                          <div class="col-5 tag_skill">
                                            <template v-for="type in topSkillsItems.Types">
                                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'baselineSkills'">F</span>
                                              <!--
                                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'definingSkills'">D</span>
                                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'necessarySkills'">N</span>
                                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'distinguishingSkills'">Dis</span>
                                              -->
                                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'specializedSkills'">S</span>
                                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'salaryBoostSkills'">$</span>
                                            </template>
                                          </div>
                                          <div class="col-12 bar_val_1" v-if="topSkillsItems.Marginal_Value !== 'null'">
                                            ${{topSkillsItems.Marginal_Value}} pa
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>

                        </template>
                      </b-tab>

                    </b-tabs>

                </div>
                <div v-else class="tabs">

                  <div class="row">

                    <div class="col-sm-3 col-xl-3 hd" style="margin-top: 20px;">
                      <h2>Job Posting Overview</h2>
                      <span class="hd_bdr"></span>
                    </div>

                    <div class="col-sm-3 col-xl-3 mt-3" v-if="formattedCareer && formattedCareer.aggregatedMedianHourlyEarning">
                      <div class="card sec_bx">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-6 msg_sec" style="padding-top: 61px;">
                              <div>
                                Median Income
                              </div>
                            </div>
                            <div class="col-6 gph_chart">
                              <div class="">
                                <doughnut-chart :chart-data="medianIncomePieData"></doughnut-chart>
                                <div class="donut_chart_val_container">
                                  <div class="donut_chart_val">
                                    <div class="gph_val">
                                      $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3 col-xl-3 mt-3" v-if="formattedCareer && formattedCareer.aggregatedLastYearJob">
                      <div class="card sec_bx">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-6 msg_sec">
                              <div>
                                Job Postings 2020 - 2030
                              </div>
                            </div>
                            <div class="col-6 gph_chart">
                              <div class="donut_chart_val">
                                <doughnut-chart :chart-data="jobPostingsPieData"></doughnut-chart>
                                <div class="donut_chart_val_container">
                                  <div class="donut_chart_val">
                                    <div class="gph_val">
                                      <span v-html="addCommaInNumber(formattedCareer.aggregatedLastYearJob)"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-3 col-xl-3 mt-3" v-if="formattedCareer && formattedCareer.aggregatedGrowthPercentage">
                      <div class="card sec_bx">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-6 msg_sec">
                              <div>
                                Estimated Job Growth in the next 10 years
                              </div>
                            </div>
                            <div class="col-6 gph_chart">
                              <div class="">
                                <doughnut-chart :chart-data="growthPieData(formattedCareer.aggregatedGrowthPercentage)" id="cos-gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('cos-gauge', formattedCareer.aggregatedGrowthPercentage)"></doughnut-chart>
                                <div class="gph_val2">
                                  {{formattedCareer.aggregatedGrowthPercentage}} %
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row lg_sec_row">
                            <span class="lg_sec_blc">
                              <span class="lg_blc lt_0"></span>
                              <span class="lg_txt"> &lt; 0%</span>
                            </span>
                            <span class="lg_sec_blc">
                              <span class="lg_blc bt_0-15"></span>
                              <span class="lg_txt"> 0-15%</span>
                            </span>
                            <span class="lg_sec_blc">
                              <span class="lg_blc gt_15"></span>
                              <span class="lg_txt"> &gt; 15%</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3 col-xl-3 mt-3 mb-3 career_chart_container">
                      <div class="row">
                        <div class="col-12 hd">
                          <div class="hd_txt">
                            <h2>Top Careers</h2>
                            <span class="hd_bdr"></span>
                          </div>
                          <div class="ace_sec_hd lnk_sec">
                            <template v-if="showEducationLevelEnabled">
                              <template v-if="showAllOccupations">
                                [<b-link @click="toggleShowOccupations()">Show Careers At Your Program Level</b-link>]
                              </template>
                              <template v-if="!showAllOccupations">
                                [<b-link @click="toggleShowOccupations()">Show All Careers</b-link>]
                              </template>
                            </template>
                          </div>
                        </div>
                      </div>

                      <!-- custom career chart -->
                      <div class="row pg_sec">

                        <div class="col-12 ace_sec" aria-label="Careers Chart">

                          <div class="avg_val ace_sec_txt" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                            <span class="avg_val_txt">
                              Median Income - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                            </span>
                          </div>
                          <div class="avg_val_connecter"></div>

                          <div class="bar_chart_container bar_label_inside">
                            <template v-for="(formattedCareer, index) in targetOccupationItems">
                              <div class="row bar_row ace_sec">
                                <div class="col-12">
                                  <!--
                                  <div id="careersDetailsToolTip" class="chart_tooltip_popover"></div>
                                  <b-popover :target="'popoverCareersDetails_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="careersDetailsToolTip">
                                    <div class="tooltip_row">
                                       <div class="val">{{ formattedCareer.name }}</div>
                                    </div>
                                    <div class="tooltip_row">
                                      <div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.medianHourlyEarning)"></span></div>
                                    </div>
                                  </b-popover>
                                  -->
                                  <div class="bar_container">
                                    <div class="bar_label">{{ formattedCareer.Occupation }} </div>
                                    <div class="bar_label" v-if="showEducationLevelEnabled"><div class="program_type_tag" v-for="edu in formattedCareer['Education'] "> <span class="tag ace_sec_txt">{{edu.level.charAt(0)}}: {{edu.score}}</span> </div></div>
                                    <div class="bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer['Median Earnings'])"></span></div>
                                    <div class="bar" v-bind:style="{width:setIncomeBarWidth(formattedCareer['Median Earnings'])}"></div>
                                  </div>

                                </div>
                              </div>
                            </template>
                          </div>
                        </div>

                      </div>
                      <!-- custom career chart -->

                      <!--
                      <div class="custom_dot_gph_conatiner">
                        <div class="career_chart">
                          <scatter-chart :data="incomeScatterData" :options="incomeScatterOptions" :height="50"></scatter-chart>
                        </div>
                        <div class="line"></div>
                      </div>
                      <div class="text-center">
                        Median Income - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                      </div>
                      -->

                    </div>
                  </div>

                </div>
              </div>

              <div class="data_source_info"  style="padding-left: 15px; margin-bottom: 25px; margin-top: 12px;" v-if="isEMSIFeatureEnabled">Data Source: Burning Glass Technologies.</div>

          </div>
        </template>
        <program-footer-navbar :pageTitle="pageTitle" :returnTo="returnTo" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProgramGuideTitle from './ProgramGuideTitle'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
import DoughnutChart from './DoughnutChart'
import ScatterChart from './ScatterChart'
import _ from 'lodash'

export default {
  name: 'program-guide-career-prospects',
  props: ['code', 'cipCode', 'programGuideCode', 'type', 'isComingFromBookmark'],
  components: {
    Navbar,
    ProgramGuideTitle,
    ProgramFooterNavbar,
    DoughnutChart,
    ScatterChart
  },
  data: () => {
    return {
      tabIndex: 0,
      isLoading: true,
      selectedState: null,
      selectedMetroArea: null,
      disableSelectState: false,
      disableSelectMetroArea: false,
      disableSelectCounty: false,
      targetOccupationItems: [],
      topCompaniesItems: [],
      topSkillsFields: ['Skill', 'Postings_with_Skill'],
      topSkillsItems: [],
      growthPieOptions: {
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        tooltips: {
          enabled: false
        }
      },
      programGuide: {},
      isStateCityFilterClicked: false,
      alumniData: {}
    }
  },
  async beforeMount () {
    this.alumniData = await this.loadProgramAlumniData(this.programGuideCode)
  },
  async mounted () {
    this.resetData()
    await this.loadDataForProgramGuideCareerProspects()
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'loadProgramGuide',
      'loadInstitutionPackage',
      'loadProgramGuideCareers',
      'loadProgramCareerResult',
      'loadAlumniStreamRecommendations',
      'loadAdvisorStreamRecommendations',
      'resetProgramCareerResult',
      'loadGeoIds',
      'updateShowAllOccupations',
      'loadProgramAlumniData'
    ]),
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['active']
      } else {
        return ['bg-primary', 'text-light']
      }
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    callDrawNeedle (el, value) {
      if (!document || !document.getElementById(el)) return
      let canvas = document.getElementById(el).childNodes[1]
      if (canvas) {
        if (value && value < -10) {
          this.drawNeedle(canvas, 50, -170 * Math.PI / 180)
        } else if (value && value >= -10 && value < -5) {
          this.drawNeedle(canvas, 50, -150 * Math.PI / 180)
        }   if (value && value >= -5 && value < 0) {
          this.drawNeedle(canvas, 50, -130 * Math.PI / 180)
        } else if (value && value >= 0 && value < 5) {
          this.drawNeedle(canvas, 50, -110 * Math.PI / 180)
        } else if (value && value >= 5 && value < 10) {
          this.drawNeedle(canvas, 50, -90 * Math.PI / 180)
        } else if (value && value >= 10 && value < 15) {
          this.drawNeedle(canvas, 50, -70 * Math.PI / 180)
        } else if (value && value >= 15 && value < 20) {
          this.drawNeedle(canvas, 50, -50 * Math.PI / 180)
        } else if (value && value >= 20 && value < 25) {
          this.drawNeedle(canvas, 50, -30 * Math.PI / 180)
        } else if (value && value >= 25) {
          this.drawNeedle(canvas, 50, -10 * Math.PI / 180)
        }
      }
    },
    drawNeedle (canvas, radius, radianAngle) {
      var ctx = canvas.getContext('2d')
      var cw = canvas.offsetWidth
      var ch = canvas.offsetHeight
      var cx = cw / 2
      var cy = ch - (ch / 4)

      ctx.translate(cx, cy)
      ctx.rotate(radianAngle)
      ctx.beginPath()
      ctx.moveTo(0, -5)
      ctx.lineTo(radius, 0)
      ctx.lineTo(0, 5)
      ctx.fillStyle = 'rgba(100, 100, 100, 1)'
      ctx.fill()
      ctx.rotate(-radianAngle)
      ctx.translate(-cx, -cy)
      ctx.beginPath()
      ctx.arc(cx, cy, 12, 0, Math.PI * 2)
      ctx.fill()
    },
    async loadDataForProgramGuideCareerProspects () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      await this.loadProgramGuideCareers({ cipCode: this.cipCode, code: this.programGuideCode, showAllOccupations: this.showAllOccupations })
      await this.loadGeoIds()
      this.isLoading = false
    },
    toggleShowOccupations () {
      this.updateShowAllOccupations(!this.showAllOccupations)
    },
    getLocationParamForCareerSearch () {
      let locationParam = ''
      let selectedState = (this.selectedState && this.selectedState.label) ? this.selectedState.label : null
      let selectedMetroArea = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : null
      let selectedCounty = (this.selectedCounty && this.selectedCounty.label) ? this.selectedCounty.label : null

      if (selectedState) {
        locationParam = 'state:' + this.labelsToCodesMap.stateGeoIds[selectedState]
      } else if (selectedMetroArea) {
        locationParam = 'msa:' + this.labelsToCodesMap.msaGeoIds[selectedMetroArea]
      } else if (selectedCounty) {
        locationParam = 'county:' + this.labelsToCodesMap.countyGeoIds[selectedCounty]
      }
      return locationParam
    },
    async careerSearchClicked () {
      this.isStateCityFilterClicked = false
      this.isLoading = true
      let careerCode = this.formattedCareer.cipCode
      let programCode = this.formattedCareer.code
      if (!careerCode) {
        this.isLoading = false
        return
      }
      let locationParam = this.getLocationParamForCareerSearch()
      await this.loadProgramCareerResult({careerCode: careerCode, programCode: programCode, locationParam: locationParam})
      this.$forceUpdate()
      this.isLoading = false
    },
    checkForCompanyName (companyName) {
      if (companyName === '[Unknown]') {
        return 'Others'
      }
      return companyName
    },
    addCommaInNumber (numValue) {
      if (numValue || numValue.length) {
        let value = Math.floor(numValue)
        return Number(value).toLocaleString()
      }
      return numValue
    },
    formatNumericVal (numValue) {
      let numericValue = Math.floor(numValue)
      return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formatOptionsForVSelect (map) {
      let formatted = []
      Object.keys(map).sort().forEach((key, i) => {
        formatted.push({id: key, label: map[key]})
      })
      formatted.sort((a, b) => (a.label >= b.label) ? 1 : -1)
      return formatted
    },
    resetData () {
      // this ensures the original program guide object info binds to the ui
      this.targetOccupationItems = []
      this.topCompaniesItems = []
      this.topSkillsItems = []
      this.resetProgramCareerResult()
    },
    hasLaborData (career) {
      if (!career) {
        return false
      }
      return career.targetOccupations || career.topPostingCompanies || career.topSkills
    },
    setIncomeBarWidth (numValue) {
      return ((numValue / (this.formattedCareer.aggregatedMedianHourlyEarning * 2)) * 100) + '%'
    },
    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    },
    closeEducationLevelTagsLegendsPopup () {
      this.$refs.educationLevelTagsLagends.$emit('close')
    },
    navigateToCareer (career) {
      console.log('career: ', career)
      if (!career.code) {
        this.$notify({
          group: 'notify',
          type: 'warning',
          title: '',
          text: 'Career does not exist.'
        })
      } else {
        let routerParams = {
          code: career.pragyaSoc,
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type,
          returnTo: 'programGuideCareerProspects'
        }
        return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'programGuideCareerProspects'} })
      }
    },
    growthPieData (value) {
      let data = {
        // labels: ['Less than 0%', '0-15%', 'Greater than 15%'],
        datasets: [
          {
            labels: 'Growth',
            backgroundColor: ['#f5b518', '#9fc958', '#0a7714'],
            data: [15, 15, 15]
          }
        ]
      }
      if (value) {
        return data
      }
      return {}
    },
    getClassOf (person) {
      if (person.educationInfoList && person.educationInfoList.length > 0) {
        return ' - Class of ' + person.educationInfoList[0].classOf
      }
      return ''
    },
    expandCollapseBio () {
      $('#biography').toggleClass('description')
      if ($('#biography').hasClass('description')) {
        $('#more-less').text('more')
      } else {
        $('#more-less').text('less')
      }
    },
    navigateToSpotlightAlumni () {
      let routeParams = {
        code: this.code,
        cipCode: this.programGuide.cipCode,
        programGuideCode: this.programGuide.code,
        returnTo: 'programGuideCareerProspects',
        type: this.programGuide.type,
        isComingFromBookmark: this.isComingFromBookmark
      }
      let queryParams = {}
      if (this.isComingFromBookmark) {
        queryParams = {returnTo: this.returnTo, pageTitle: this.pageTitle}
      }
      return this.$router.push({name: 'programGuideSpotlightAlumni', params: routeParams, query: queryParams})
    }
  },
  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'geoIdMap': state => state.career.geoIdMap,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages,
      'showAllOccupations': state => state.programguide.showAllOccupations
    }),
    isComingFromLearnerDashboard () {
      return (this.$route.query && (this.$route.query.returnTo === 'learnerDashboard'))
    },
    returnTo () {
      return this.isComingFromLearnerDashboard ? 'learnerDashboard' : 'programGuideMenu'
    },
    pageTitle () {
      return this.isComingFromLearnerDashboard ? 'Learner Dahsboard' : 'Career Prospects'
    },
    showEducationLevelEnabled () {
      let educationLevelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_EDUCATION_LEVEL]
      return educationLevelFeature && educationLevelFeature.enabled
    },
    isEMSIFeatureEnabled () {
      let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
      let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
      return ((emsiFeature && emsiFeature.enabled) || (bgtFeature && bgtFeature.enabled))
    },
    companiesTreeMapData () {
      if (this.formattedCareer && this.formattedCareer.topPostingCompanies) {
        let jsonData = {
          name: ' ',
          children: []
        }
        /*
        this.formattedCareer.topPostingCompanies.forEach((career) => {
          let parsedCareer = JSON.parse(career)
          let careerObj = {
            name: parsedCareer.name,
            value: parsedCareer.unique_postings
          }
          jsonData.children.push(careerObj)
        })
        */
        let length = this.formattedCareer.topPostingCompanies.length
        let count = (length < 4) ? length : 4
        for (var i = 0; i < count; i++) {
          let parsedCareer = JSON.parse(this.formattedCareer.topPostingCompanies[i])
          let name = parsedCareer.name
          let value = parsedCareer.unique_postings
          if (parsedCareer.name === '[Unknown]') {
            name = 'Others'
          }
          if (parsedCareer.name === 'ACCENTURE, INC.') {
            name = 'Accenture'
          }
          if (parsedCareer.name === 'Robert Half International Inc.') {
            name = 'Robert Half'
          }
          let careerObj = {
            name: name,
            value: value
          }
          jsonData.children.push(careerObj)
        }
        return jsonData
      }
      return {}
    },
    skillsTreeMapData () {
      if (this.formattedCareer && this.formattedCareer.topSkills) {
        let jsonData = {
          name: 'Top Skills',
          children: []
        }
        /*
        this.formattedCareer.topSkills.forEach((career) => {
          let parsedCareer = JSON.parse(career)
          let careerObj = {
            name: parsedCareer.name,
            value: parsedCareer.unique_postings
          }
          jsonData.children.push(careerObj)
        })
        */
        let length = this.formattedCareer.topSkills.length
        let count = (length < 4) ? length : 4
        for (var i = 0; i < count; i++) {
          let parsedCareer = JSON.parse(this.formattedCareer.topSkills[i])
          let name = parsedCareer.name
          if (name === 'JavaScript (Programming Language)') {
            name = 'JavaScript'
          }
          if (name === 'Java (Programming Language)') {
            name = 'Java'
          }
          if (name === 'Agile Software Development') {
            name = 'Agile'
          }
          let careerObj = {
            name: name,
            value: parsedCareer.unique_postings
          }
          jsonData.children.push(careerObj)
        }
        return jsonData
      }
      return {}
    },
    incomeScatterOptions () {
      let options = {
        scales: {
          yAxes: [{
            display: false,
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 1,
              stepSize: 1
            },
            gridLines: {
              display: false,
              color: 'rgba(0, 0, 0, 0)',
              drawOnChartArea: false
            }
          }],
          xAxes: [{
            ticks: {
              maxTicksLimit: 4,
              scaleFontSize: 14
            },
            gridLines: {
              color: 'rgba(0, 0, 0, 0)',
              drawOnChartArea: false
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.labels[tooltipItem.index]
              var getSalary = Math.round(tooltipItem.xLabel)
              var formatSalary = '$' + getSalary.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              return label + ' - [' + formatSalary + ']'
            }
          },
          titleMarginBottom: 8,
          bodySpacing: 10,
          xPadding: 10,
          yPadding: 15,
          cornerRadius: 2,
          backgroundColor: 'rgb(255, 255, 255)',
          bodyFontColor: 'rgb(48, 48, 48)',
          bodyFontSize: '14',
          caretPadding: 10,
          displayColors: false
        }
      }
      return options
    },
    incomeScatterData () {
      if (this.formattedCareers) {
        let data = {
          labels: [],
          datasets: [
            {
              label: '',
              fill: false,
              borderWidth: 0,
              borderColor: 'rgb(245, 245, 245)',
              backgroundColor: 'rgb(245, 245, 245)',
              pointRadius: 8,
              pointHoverRadius: 10,
              pointBackgroundColor: '#157099',
              pointBorderWidth: 2,
              pointBorderColor: '#014966',
              data: []
            }
          ]
        }
        this.formattedCareers.forEach((career) => {
          let dataPoint = {
            x: career.medianHourlyEarning,
            y: this.getRandomInt(0, 1)
          }
          data.datasets[0].data.push(dataPoint)
          data.labels.push(career.name)
        })
        return data
      }
      return {}
    },
    jobPostingsPieData () {
      let data = {
        datasets: [
          {
            label: 'Job Postings',
            borderWidth: 0,
            backgroundColor: '#8db350',
            data: []
          }
        ]
      }
      if (this.formattedCareer && this.formattedCareer.aggregatedLastYearJob) {
        data.datasets[0].data.push(this.formattedCareer.aggregatedLastYearJob)
      }
      return data
    },
    medianIncomePieData () {
      let data = {
        // labels: ['Median Income'],
        datasets: [
          {
            label: 'Median Income',
            borderWidth: 0,
            backgroundColor: '#8db350',
            cutout: 100,
            data: []
          }
        ]
      }
      if (this.formattedCareer && this.formattedCareer.aggregatedMedianHourlyEarning) {
        data.datasets[0].data.push(this.formattedCareer.aggregatedMedianHourlyEarning)
      }
      return data
    },
    formattedCareers () {
      let formattedCareers = []
      let careers = this.careersObject
      if (!this.hasLaborData(careers)) {
        return []
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      formattedCareers = formattedCareers.sort((a, b) => (parseFloat(a.medianHourlyEarning) <= parseFloat(b.medianHourlyEarning)) ? 1 : -1)
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!this.hasLaborData(formattedCareer)) {
        return {}
      }
      this.resetData()
      formattedCareer.targetOccupations.forEach((career, i) => {
        let curr = JSON.parse(career)
        if (i === 0) {
          formattedCareer.timeframe = curr.timeframe
          formattedCareer.endYear = curr.year
          formattedCareer.startYear = formattedCareer.endYear - 10
          formattedCareer.tenYearOldJobTitle = curr.tenYearOldJobTitle
        }
        let tenYearOldJobTitle = formattedCareer.tenYearOldJobTitle
        let growthTitle = 'Growth (' + formattedCareer.timeframe + ')'
        let currItem = {
          'Occupation': curr.name,
          'Annual Openings': curr.annualOpening,
          'Median Earnings': curr.medianHourlyEarning,
          'Education': curr.education,
          'code': curr.code,
          'pragyaSoc': curr.pragyaSoc
        }
        currItem[tenYearOldJobTitle] = curr.tenYearOldJob
        currItem[growthTitle] = curr.growth
        this.targetOccupationItems.push(currItem)
      })

      this.targetOccupationItems = this.targetOccupationItems.sort((a, b) => (parseFloat(a['Median Earnings']) <= parseFloat(b['Median Earnings'])) ? 1 : -1)

      if (!formattedCareer.topPostingCompanies) {
        return formattedCareer
      }

      formattedCareer.topPostingCompanies.forEach((company, i) => {
        let curr = JSON.parse(company)
        let tenYearPostingTitle = 'Total/Unique (' + formattedCareer.timeframe + ')'
        let currItem = {'Company': curr.name}
        currItem[tenYearPostingTitle] = curr.total_postings + ' / ' + curr.unique_postings
        currItem['Total'] = curr.total_postings
        currItem['Unique'] = curr.unique_postings
        currItem['Posting Intensity'] = (Math.round(curr.posting_intensity)) + ':1'
        this.topCompaniesItems.push(currItem)
      })
      this.topCompaniesItems = this.topCompaniesItems.sort((a, b) => (Number(a.Total) <= Number(b.Total)) ? 1 : -1)
      if (!formattedCareer.topSkills) {
        return formattedCareer
      }

      formattedCareer.topSkills.forEach((skill, i) => {
        let curr = JSON.parse(skill)
        let currItem = {'Skill': curr.name, 'Postings_with_Skill': curr.unique_postings,
        'Types': curr.types,
        'Marginal_Value': curr.marginal_value}
        this.topSkillsItems.push(currItem)
      })
      this.topSkillsItems = this.topSkillsItems.sort((a, b) => (Number(a.Postings_with_Skill) <= Number(b.Postings_with_Skill)) ? 1 : -1)
      return formattedCareer
    },
    formattedGeoIdMap () {
      let formattedMap = {}
      let map = this.geoIdMap

      if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
        formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
        formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
        formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
      }
      return formattedMap
    },
    labelsToCodesMap () {
      let map = this.geoIdMap
      let formattedMap = {}
      if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
        formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
        formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
        formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
      }
      return formattedMap
    },
    targetOccupationFields () {
      let fields = ['Occupation']
      if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
        let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
        fields.push((curr.tenYearOldJobTitle))
        fields.push('Annual Openings')
        fields.push('Median Earnings')
        fields.push('Growth (' + curr.timeframe + ')')
        return fields
      } else {
        return []
      }
    },
    topCompaniesFields () {
      let fields = ['Company']
      if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
        let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
        fields.push('Total/Unique (' + curr.timeframe + ')')
        fields.push('Posting Intensity')
        return fields
      } else {
        return []
      }
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    showAlumniData () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showAlumniData) {
        return false
      }
      return this.alumniData && exploreProgramDetailFlagMap.showAlumniData.enabled
    },
    showCareerEmoloyerJob (){
      return this.alumniData && (this.alumniData.topCareerTitle || this.alumniData.topCompanyTitle  || this.alumniData.totalHireLastYearHire )
    },
    spotlightAlumni () {
      if (this.alumniData.spotlightPerson && this.alumniData.spotlightPerson.length > 0) {
        return this.alumniData.spotlightPerson[0]
      }
      return null
    }
  },
  watch: {
    showAllOccupations (newShowAllOccupations) {
      this.loadDataForProgramGuideCareerProspects()
    },
    selectedState (newState) {
      if (!newState) {
        this.disableSelectState = false
        this.disableSelectMetroArea = false
        this.disableSelectCounty = false
      } else {
        this.disableSelectState = false
        this.disableSelectMetroArea = true
        this.disableSelectCounty = true
      }
    },
    selectedMetroArea (newMSA) {
      if (!newMSA) {
        this.disableSelectState = false
        this.disableSelectMetroArea = false
        this.disableSelectCounty = false
      } else {
        this.disableSelectState = true
        this.disableSelectMetroArea = false
        this.disableSelectCounty = true
      }
    }
  }
}
</script>

<style scoped>
  .description {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-box-pack: center;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideCareerProspects.vue